import React, { Component} from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link, IndexLink } from 'react-router';

import { downloadParticipants, checkoutFilter } from './actions';
import './style.css';


class Participants extends Component {

  componentWillMount() {
    if (this.props.participants.counts.all === 0) {
      this.props.downloadParticipants();
    }
    window.scrollTo(0, 0);
  }

  render() {
    const baseUrl = '/participants';

    const ifShowTabs = this.props.participants.sections && this.props.participants.sections.length > 1;
    const tabs = this.props.participants.sections.map(section => (
      <Link
        key={section.id} type={section.id} to={`${baseUrl}/${section.id}`}
        className={'speaker__tabs-item participants__tabs-item speaker__tabs-item-' + section.id}
        activeClassName={'speaker__tabs-item_' + section.id}
      >
        {`${section.name}(${this.props.participants.counts[section.id]})`}
      </Link>
    ));

    return (
      <div className='participants'>
        <div className='participants__title'>
          Участники
          {
            ifShowTabs
            ? null
            : (
              <span>
                ({this.props.participants.counts.all})
              </span>
            )
          }
        </div>
        <div className='participants__container'>
          {
            ifShowTabs
            ? (
              <div className='speaker__tabs'>
                <IndexLink
                  to={baseUrl}
                  className='speaker__tabs-item participants__tabs-item speaker__tabs-item-all'
                  activeClassName='speaker__tabs-item_all'
                >
                  все ({this.props.participants.counts.all})
                </IndexLink>
                  {tabs}
              </div>
            ) : null
          }
          <div
            className='participant__filter'
            onClick={this.props.checkoutFilter.bind(this)}
          >
            {this.props.filterText}
          </div>
          {this.props.children}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  byEducation: state.participants.byEducation,
  filterText: state.participants.filterText,
  participants: state.participants.participants
});

const mapDispatchToProps = (dispatch) => ({
  downloadParticipants: bindActionCreators(downloadParticipants, dispatch),
  checkoutFilter: bindActionCreators(checkoutFilter, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps, null, { pure: false })(Participants);



// WEBPACK FOOTER //
// ./src/participants-page/Participants.js